import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'jsonParam'
})
export class JsonParamPipe implements PipeTransform {

  transform(jsonString: string, parameter: string): any {
    let ret = '';
    try {
      if (parameter == null) {
        return ret;
      }

      let jsonobject;

      try {
        jsonobject = JSON.parse(jsonString);
      } catch {
          jsonobject = jsonString;
      }

      if (parameter === 'FullName') {
        if (jsonobject.FirstName) {
          ret += jsonobject.FirstName;
        }

        if (jsonobject.LastName) {
          if (jsonobject.FirstName) {
            ret += ' ';
          }
          ret += jsonobject.LastName;
        }
      } else {
        ret = eval('jsonobject.' + parameter);
      }
      return ret;
    } catch (error) {
      // console.log(error);
      return ret;
    }
  }
}
